
export default {
   props: ['texte1Paragraphe1','texte1Paragraphe2','texte1Paragraphe3', 
   'adresse1', 'adresse2','tel', 'email', 'horaires', 'numeroUAI','numeroDF'],
}
